import script from "./customPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./customPagination.vue?vue&type=script&setup=true&lang=js"

import "./customPagination.vue?vue&type=style&index=0&id=32d7d3c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32d7d3c2"]])

export default __exports__